import React, { useEffect, useState } from "react";
import { serverConfig } from "../ApiSearchPath/ApiSearchPath";
//import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useSearchParams } from 'react-router-dom';
import DoctorsService from "../Doctors/Services/DoctorsService";
import Swal from "sweetalert2";
//import { searchDoctors } from "../Doctors/Services/searchDoctors";
//import { DoctorsService } from "../Doctors/Services/DoctorsService";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
export default function CompanyProfile() {
  useEffect(() => {
    const scriptUrls = [
      "assets/js/jquery-3.7.1.min.js",
      "assets/js/bootstrap.bundle.min.js",
      "assets/js/owl.carousel.min.js",
      "assets/plugins/fancybox/jquery.fancybox.min.js",
      "assets/js/script.js"
    ];

    let isCancelled = false;

    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.async = false;
          script.onload = () => {
            console.log(`Loaded: ${url}`);
            resolve();
          };
          script.onerror = () => {
            console.error(`Failed to load: ${url}`);
            reject();
          };
          document.body.appendChild(script);
        });
      }

      // Now init plugins after scripts are loaded
      if (!isCancelled) {
        // if (window.AOS) {
        //   window.AOS.init();
        // }

        if (window.$ && typeof window.$.fn.datetimepicker === 'function') {
          window.$('.datetimepicker').datetimepicker();
        }

        if (typeof window.initBackToTop === 'function') {
          window.initBackToTop(); // assuming your backToTop script defines this
        }

        console.log('All scripts loaded and initialized.');
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
    };
  }, []);
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get("query");

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  // ← THIS IS THE API CALL YOU WANTED (runs AFTER navigation, triggered by query)
  useEffect(() => {
    const fetchMainDoctor = async () => {
      if (!companyId) {
        setLoading(false);
        return;
      }

      try {
        const response = await DoctorsService.searchCompany(companyId);
        const hospitalData = response.data.data;
        console.log("Company data received (from query):", hospitalData);
        setCompany(hospitalData);
      } catch (error) {
        console.error("Error fetching company:", error);
        setCompany(null);
      } finally {
        setLoading(false);
      }
    };

    fetchMainDoctor();
  }, [companyId]);
  console.log("company data received:", company);
  const navigate = useNavigate();
  const handleClick = (e, divid) => {
    e.preventDefault(); // This prevents full page reload
    document.getElementById(divid)?.scrollIntoView({ behavior: "smooth" });
  };
  function toTitleCase(str) {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  // const doctorsSearchByCompany = async (e,keyword) => {
  //     e.preventDefault();

  //     const combinedKeyword = `${keyword}`.trim();

  //     try {
  //       localStorage.clear();
  //       const response = await searchDoctors(combinedKeyword);
  //       console.log("Search results:", response.data);
  //       navigate("/search-doctors", { state: { results: response.data.data.flat() } });
  //       // you can store response.data into state and render it
  //     } catch (error) {
  //       console.error("Search error:", error);
  //     }
  //   };
  const handleDoctors = async (e, doctorId) => {
    e.preventDefault();
    navigate(`/doctor-profile?query=${doctorId}`);
  };
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true, // Ensures navigation is visible
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };
   const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <style>{`
.content {
 padding-top:2px;
 margin-top:2px;
}
 .error-title {
  color: #ed4e2b !important;
}
.insurence-logo {
  padding: 10px;
}
  .clinic-img{
   width:80% !important;
   height:auto !important;
  //  margin-left:10%;
   margin-right:10%;
}
   .image{
    width:100% !important;
   height:auto !important;
   }
  @media (max-width: 767px) {
   .doctor-img {
    text-align: center;
    margin: 0 auto !important;

  }
    .slick-prev {
      left:1px !important;
    }
    .slick-next{
      right:1px !important;
  }

  .information-title-list {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    white-space: nowrap;
    gap: 10px;
  }


  .information-title-list li {
    flex: 0 0 auto;
  }

  .information-title-list::-webkit-scrollbar {
    display: none;
  }
}
  /* Default (desktop) - no change */
.special-links {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

/* Mobile scrolling */
@media (max-width: 768px) {
  .scroll-mobile {
    flex-wrap: nowrap !important;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
  }

  .scroll-mobile::-webkit-scrollbar {
    display: none; /* Chrome */
  }

  .scroll-mobile li {
    flex: 0 0 auto;
  }

  .scroll-mobile a {
    display: inline-block;
    padding: 6px 12px;
    font-size: 12px;
    white-space: nowrap;
  }
}
  .information-title-list {
  display: flex;
  overflow-x: auto;   /* enables horizontal scroll */
  white-space: nowrap;
  padding: 0;
  margin: 0;
  list-style: none;
  scrollbar-width: thin; /* Firefox */
}

.information-title-list li {
  flex: 0 0 auto; /* prevent items from shrinking */
}

.information-title-list li a {
  display: inline-block;
  padding: 10px 15px;
  text-decoration: none;
}

/* Optional: Hide scrollbar (Chrome, Edge, Safari) */
.information-title-list::-webkit-scrollbar {
  height: 6px;
}

.information-title-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}
  .scroll-mobile {
  display: flex;
  overflow-x: auto;        /* enable horizontal scroll */
  white-space: nowrap;
  gap: 10px;
  padding: 5px 0;

  scrollbar-width: thin;   /* Firefox */
}

/* Prevent items from shrinking */
.scroll-mobile li {
  flex: 0 0 auto;
  list-style: none;
}

/* Style links like pills */
.scroll-mobile li a {
  display: inline-block;
  padding: 8px 14px;
  background: #f1f1f1;
  border-radius: 20px;
  text-decoration: none;
  color: #333;
  font-size: 14px;
}

/* Hover effect */
.scroll-mobile li a:hover {
  background: #007bff;
  color: #fff;
}

/* Scrollbar styling (Chrome, Edge, Safari) */
.scroll-mobile::-webkit-scrollbar {
  height: 6px;
}

.scroll-mobile::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}
    `}</style>
      {(loading) ?
        (<>
          {/* Breadcrumb still shows (looks professional) */}
          <div className="breadcrumb-bar">
            <div className="container">
              <div className="row align-items-center inner-banner">
                <div className="col-md-12 col-12 text-center">
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    {/* <ol className="breadcrumb">
                      <li className="breadcrumb-item"><a href="/main-page"><i className="isax isax-home-15" /></a></li>
                      <li className="breadcrumb-item" aria-current="page">Doctors</li>
                      <li className="breadcrumb-item active">Hospital Profile</li>
                    </ol> */}
                    <h2 className="breadcrumb-title">Hospital Profile</h2>
                  </nav>
                </div>
              </div>
            </div>
            <div className="breadcrumb-bg">
              <img src="assets/img/bg/breadcrumb-bg-01.png" alt="img" className="breadcrumb-bg-01" />
              <img src="assets/img/bg/breadcrumb-bg-02.png" alt="img" className="breadcrumb-bg-02" />
              <img src="assets/img/bg/breadcrumb-icon.png" alt="img" className="breadcrumb-bg-03" />
              <img src="assets/img/bg/breadcrumb-icon.png" alt="img" className="breadcrumb-bg-04" />
            </div>
          </div>

          {/* Centered Loading Processor */}
          <div className="content">
            <div className="container">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "60vh" }}
              >
                <div className="text-center">
                  {/* Beautiful spinning loader using your existing Font Awesome */}
                  <i
                    className="fa-solid fa-spinner fa-spin fa-4x mb-4"
                    style={{ color: "#0d6efd" }}
                  />
                  <h4 className="mb-2">Loading Hospital Profile...</h4>
                  <p className="text-muted">Please wait while we fetch the details</p>
                </div>
              </div>
            </div>
          </div>
        </>)
        : (company?.company?.showIdentity === 'N' || !company?.company?.showIdentity) ? (<>
          {/* Breadcrumb still shows (looks professional) */}
          <div className="breadcrumb-bar">
            <div className="container">
              <div className="row align-items-center inner-banner">
                <div className="col-md-12 col-12 text-center">
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    {/* <ol className="breadcrumb">
                      <li className="breadcrumb-item"><a href="/main-page"><i className="isax isax-home-15" /></a></li>
                      <li className="breadcrumb-item" aria-current="page">Doctors</li>
                      <li className="breadcrumb-item active">Hospital Profile</li>
                    </ol> */}
                    <h2 className="breadcrumb-title">Hospital Profile</h2>
                  </nav>
                </div>
              </div>
            </div>

          </div>

          {/* Centered Loading Processor */}
          <div className="content">
            <div className="container">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "20vh" }}
              >
                <div className="text-center">
                  {/* Beautiful spinning loader using your existing Font Awesome */}
                  {/* <i
                    className="fa-solid fa-spinner fa-spin fa-4x mb-4"
                    style={{ color: "#0d6efd" }}
                  /> */}
                  <h2 className="mb-2 error-title">Hospital not verified!</h2>
                  <p className="text-muted">Please search other hospital, this is not verified.</p>
                </div>
              </div>
            </div>
          </div>
        </>) : (
          <div>
            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
              <div className="container">
                <div className="row align-items-center inner-banner">
                  <div className="col-md-12 col-12 text-center">
                    <nav aria-label="breadcrumb" className="page-breadcrumb">
                      {/* <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/main-page"><i className="isax isax-home-15" /></a></li>
                        <li className="breadcrumb-item" aria-current="page">Hospital</li>
                        <li className="breadcrumb-item active">Hospital Profile</li>
                      </ol> */}
                      <h2 className="breadcrumb-title">Hospital Profile</h2>
                    </nav>
                  </div>
                </div>
              </div>
              <div className="breadcrumb-bg">
                <img src="assets/img/bg/breadcrumb-bg-01.png" alt="bmg" className="breadcrumb-bg-01" />
                <img src="assets/img/bg/breadcrumb-bg-02.png" alt="bmg" className="breadcrumb-bg-02" />
                <img src="assets/img/bg/breadcrumb-icon.png" alt="bmg" className="breadcrumb-bg-03" />
                <img src="assets/img/bg/breadcrumb-icon.png" alt="bmg" className="breadcrumb-bg-04" />
              </div>
            </div>
            {/* /Breadcrumb */}
            {/* Page Content */}
            <div className="content">
              <div className="container">
                {/* company? Widget */}
                <div className="card doc-profile-card">
                  <div className="card-body">
                    <div className="doctor-widget doctor-profile-two row align-items-center">
                      <div className="doc-info-left col-xl-6 col-lg-6 col-md-12 col-12">
                        <div style={{ width: "100%" }}>
                          <img src={`${serverConfig.BASE_URL}/uploads/company/${company?.company?.logoImg}`}
                            style={{
                              height: 'auto',
                              maxWidth: '100%',
                            }}
                            className="img-fluid" alt="Hospital "
                            onError={(e) => {
                              e.target.onerror = null; // prevents infinite loop
                              e.target.src = "assets/img/hospital.jpg";
                            }} />
                        </div>
                        <div className="doc-info-cont d-flex flex-column align-items-center align-items-md-start text-center text-md-start">

                          {/* <span className="badge doc-avail-badge"><i className="fa-solid fa-circle"/>Always Available </span> */}

                          <h4 className="doc-name">
                            {company?.company?.companyName?.split(' ')
                              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                              .join(' ')}

                            <img src="assets/img/icons/badge-check.svg" alt="alt" className="ms-2" />
                          </h4>
                          <h4 className="doc-name" style={{ marginLeft: "0px" }}>
                            <span className="badge doctor-role-badge mt-2">
                              <i className="fa-solid fa-circle me-1" />
                              {company?.company?.companyTypeName}
                            </span>
                          </h4>
                          <p className="mb-1" style={{ color: 'blue', fontWeight: '600' }}>Speciality :
                            {company?.companySpeciality?.slice(0, 3).map((item, index) => (
                              <span key={index}>{toTitleCase(item.speciality)}&nbsp;</span>
                            ))}
                          </p>

                          <p className="mb-1">
                            Services : {company?.companyServices?.slice(0, 3).map((item, index) => (
                              <span key={index}>{toTitleCase(item.service)}&nbsp;</span>
                            ))}
                          </p>

                          <p className="address-detail mb-1">
                            <span className="loc-icon me-1" style={{ color: 'black', fontWeight: '600' }}>
                              <i className="feather-map-pin" />
                            </span>
                            {company?.company?.officeAddress}
                          </p>

                          <p className="address-detail">
                            <span
                              className="view-text text-primary"
                              role="button"
                              onClick={(e) => handleClick(e, "clinic")}
                            >
                              ( View Location )
                            </span>
                          </p>

                        </div>
                      </div>
                      <div className="doc-info-right">
                        <ul className="doctors-activities">
                          <li>
                            <div className="hospital-info">
                              {/* <span className="list-icon"><img src="assets/img/icons/watch-icon.svg" alt="Img" /></span>
                    <p>Full Time, Online Therapy Available</p> */}
                            </div>
                            {/* <ul className="sub-links">
                    <li><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}><i className="feather-heart" /></a></li>
                    <li><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}><i className="feather-share-2" /></a></li>
                    <li><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}><i className="feather-link" /></a></li>
                  </ul> */}
                          </li>
                          <li>
                            <div className="hospital-info">
                              {/* <span className="list-icon"><img src="assets/img/icons/thumb-icon.svg" alt="Img" /></span>
                    <p><b>94% </b> Recommended</p> */}
                            </div>
                          </li>

                          <li>
                            {/* <div className="rating">
                    <i className="fas fa-star filled" />
                    <i className="fas fa-star filled" />
                    <i className="fas fa-star filled" />
                    <i className="fas fa-star filled" />
                    <i className="fas fa-star filled" />
                    <span>5.0</span>
                    <a href="#" className="d-inline-block average-rating">150 Reviews</a>
                  </div> */}
                            <ul className="contact-doctors">

                              {company?.appointment?.chat === 'Y' && (
                                <li>
                                  <a href="/" role="button" onClick={(e) => { e.preventDefault() }}>
                                    <span className="bg-grey"><i className="feather-message-square" /></span>
                                    Chat
                                  </a>
                                </li>
                              )}
                              {company?.appointment?.clinic === 'Y' && (
                                <li>
                                  <a href="/" role="button" onClick={(e) => { e.preventDefault() }}><span className="bg-grey"><i className="feather-briefcase" /></span>Clinics</a>
                                </li>
                              )}
                              {company?.appointment?.audioCall === 'Y' && (
                                <li><a href="/" role="button" onClick={(e) => { e.preventDefault() }}><span className="bg-grey"><i className="feather-phone-forwarded" /></span>Audio Call</a></li>
                              )}
                              {company?.appointment?.videoCall === 'Y' && (
                                <li><a href="/" role="button" onClick={(e) => { e.preventDefault() }}><span className="bg-grey"><i className="feather-camera" /></span>Video Call</a></li>
                              )}
                              {company?.appointment?.homeVisit === 'Y' && (
                                <li><a href="/" role="button" onClick={(e) => { e.preventDefault() }}><span className="bg-grey"><i className="feather-home" /></span>Home Visit</a></li>
                              )}


                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="doc-profile-card-bottom">
                      <ul>
                        {company?.countOfAppointments>20?
                        <li>
                          <span className="bg-blue"><img src="assets/img/icons/calendar3.svg" alt="asd" /></span>
                          Nearly {(company?.countOfAppointments > 1000) ? 1000 :
 (company?.countOfAppointments > 500) ? 500 :
 (company?.countOfAppointments > 200) ? 200 :
 (company?.countOfAppointments > 100) ? 100 :
 (company?.countOfAppointments > 50) ? 50 :
 (company?.countOfAppointments > 20) ? 20 :
 <></>}+ Appointment Booked
                        </li>:<></>}
                        {(company?.countOfDoctors)>0?
                        <li>
                          <span className="bg-dark-blue"><img src="assets/img/icons/bullseye.svg" alt="asd" /></span>
                          We have {company?.countOfDoctors} doctors.
                        </li>:<></>
                        }
                      </ul>
                      <div className="bottom-book-btn">
                        {/* <p><span>Price : {company?.company.consultationFee} </span> for a consultation</p> */}
                        <div className="clinic-booking">
                          <a href="/" role="button" className="apt-btn" onClick={(e) => handleClick(e, "doctors")}>Book Appointment</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /company? Widget */}
                <div className="doctors-detailed-info">
                  <ul className="information-title-list">
                    <li className="active">
                      <a href="/" role="button" onClick={(e) => handleClick(e, "company_bio")}>Hospital info</a>
                    </li>
                    <li>
                      <a href="/" role="button" onClick={(e) => handleClick(e, "doctors")}>Doctors</a>
                    </li>
                    <li>
                      <a href="/" role="button" onClick={(e) => handleClick(e, "insurence")}>Insurances</a>
                    </li>
                    <li>
                      <a href="/" role="button" onClick={(e) => handleClick(e, "images")}>Images</a>
                    </li>
                    <li>
                      <a href="/" role="button" onClick={(e) => handleClick(e, "services")}>Speciality</a>
                    </li>
                    <li>
                      <a href="/" role="button" onClick={(e) => handleClick(e, "speciality")}>Services</a>
                    </li>
                    <li>
                      <a href="/" role="button" onClick={(e) => handleClick(e, "clinic")}>Clinics</a>
                    </li>
                    {/* <li>
            <a onClick={(e)=>handleClick(e,"membership")}>Memberships</a>
          </li>
          <li>
            <a onClick={(e)=>handleClick(e,"awards")}>Awards</a>
          </li>
          <li>
            <a onClick={(e)=>handleClick(e,"bussiness_hour")}>Business Hours</a>
          </li> */}
                    <li>
                      <a href="/" role="button" onClick={(e) => handleClick(e, "review")}>Review</a>
                    </li>
                  </ul>
                  <div className="doc-information-main mt-4">
                    <div className="doc-information-details bio-detail" id="company_bio">
                      <div className="detail-title">
                        <h4>Hospital info</h4>
                      </div>
                      <p dangerouslySetInnerHTML={{
                        __html: company?.companyBio?.bio || "This is the best hospital in the city."
                      }}>
                      </p>

                      {/* <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="show-more d-flex align-items-center">See More<i className="fa-solid fa-chevron-down ms-2" /></a> */}
                    </div>
                    <div className="doc-information-details" id="doctors">
                      <div className="detail-title">
                        <h4>Doctors</h4>
                      </div>
                      {company?.doctorsRspo?.map((doctors, index) => (
                        <><div className="experience-info" key={index}>
                          <div className="experience-logo">
                            <span><img src={`${serverConfig.BASE_URL}/uploads/${doctors.doctorImg}`} alt="asd" style={{
                              height: '200px',
                              width: '100%',
                              // objectFit: 'cover',
                            }}

                              onError={(e) => {
                                e.target.onerror = null; // prevents infinite loop
                                e.target.src = "assets/img/doctor.png";
                              }} /></span>
                          </div>
                          <div className="experience-content">
                            <h5><Link onClick={(e) => {
                                                                    e.preventDefault();
                                                                    doctors?.showIdentity === 'Y' &&
                                                                    doctors?.kycAccept === 'Y'
                                                                      ? handleDoctors(e,doctors.userId)
                                                                      : Swal.fire({
                                                                        title: 'Warning!',
                                                                        text: 'Identity is not verified.',
                                                                        icon: 'warning',
                                                                        confirmButtonColor: '#566fe2',
                                                                        customClass: {
                                                                          title: 'swal-title-small',
                                                                          popup: 'swal-popup-small',
                                                                          confirmButton: 'swal-button-small'
                                                                        }
                                                                      });
                                                                  }}>{"Dr. " + toTitleCase(doctors?.doctorName)}</Link></h5>
                            <ul className="ent-list">
                              <li>{toTitleCase(doctors?.doctorSpecialities)}</li>

                            </ul>
                            <ul className="date-list">
                              <li>{doctors?.qualification} </li>

                            </ul>
                            <ul className="date-list">
                              <li>
                                <div className="row row-sm">
                                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                    <button 
                                     onClick={(e) => {
                                                                    e.preventDefault();
                                                                    doctors?.showIdentity === 'Y' &&
                                                                    doctors?.kycAccept === 'Y'
                                                                      ? handleDoctors(e,doctors.userId)
                                                                      : Swal.fire({
                                                                        title: 'Warning!',
                                                                        text: 'Identity is not verified.',
                                                                        icon: 'warning',
                                                                        confirmButtonColor: '#566fe2',
                                                                        customClass: {
                                                                          title: 'swal-title-small',
                                                                          popup: 'swal-popup-small',
                                                                          confirmButton: 'swal-button-small'
                                                                        }
                                                                      });
                                                                  }}
                                     className="btn view-btn" style={{ minWidth: "100px" }}>View Profile</button>
                                  </div>
                                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                    <button 
                                       onClick={(e) => {
                                                                    e.preventDefault();
                                                                    doctors?.showIdentity === 'Y' &&
                                                                    doctors?.kycAccept === 'Y'
                                                                      ? navigate(`/booking?doctorId=${doctors?.userId}`)
                                                                      : Swal.fire({
                                                                        title: 'Warning!',
                                                                        text: 'Identity is not verified.',
                                                                        icon: 'warning',
                                                                        confirmButtonColor: '#566fe2',
                                                                        customClass: {
                                                                          title: 'swal-title-small',
                                                                          popup: 'swal-popup-small',
                                                                          confirmButton: 'swal-button-small'
                                                                        }
                                                                      });
                                                                  }}

                                     className="btn book-btn" style={{ minWidth: "100px" }}>Book Now</button>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        </>
                      ))}
                    </div>
                    <div className="doc-information-details" id="insurance">
                      <div className="detail-title slider-nav d-flex justify-content-between align-items-center">
                        <h4>Insurance  Accepted ({company?.countOfInsurences})</h4>

                      </div>
                      <Slider {...settings}>
                        {company?.companyInsure?.filter(
                          (insure, index, self) =>
                            index === self.findIndex(i => i.insuranceName === insure.insuranceName)
                        ).map((insure) => (
                          <div key={insure.companyInsuranceId || insure.imageUrl} className="insurence-logo">
                            <img
                              src={`${serverConfig.BASE_URL}/${insure.imageUrl}`}
                              alt={insure.insuranceName}
                              style={{ height: '150px', width: '100%', margin: 'auto', padding: '5px' }}
                              onError={(e) => {
                                e.target.onerror = null; // prevents infinite loop
                                e.target.src = "assets/img/insurance.jpg";
                              }}
                            />
                          </div>
                        ))}
                      </Slider>
                    </div>
                    <div className="doc-information-details" id="images">
                      <div className="detail-title slider-nav d-flex justify-content-between align-items-center">
                        <h4>Hospital Gallery</h4>
                      </div>
                      <Slider {...settings}>
                        {company?.companyImgs?.map((image) => (
                          <div key={image.companyImagesId} className="insurence-logo">
                            <img
                              src={`${serverConfig.BASE_URL}/${image.imageUrl}`}
                              alt={"image(" + image.companyImagesId + ")"}
                              style={{
                                height: '250px',
                                width: '100%',
                                // objectFit: 'cover',
                                marginBottom: '10px',
                                padding: '5px'
                              }}
                              onError={(e) => {
                                e.target.onerror = null; // prevents infinite loop
                                e.target.src = "assets/img/hospital.jpg";
                              }}
                            />
                          </div>
                        ))}
                      </Slider>
                    </div>
                    <div className="doc-information-details" id="speciality">
                      <div className="detail-title">
                        <h4>Speciality</h4>
                      </div>

                      <ul className="special-links scroll-mobile">
                        {company?.companySpeciality?.map((speciality, index) => (
                          <li key={index}>
                            <a href="/" role="button" onClick={(e) => e.preventDefault()}>
                              {speciality.speciality}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="doc-information-details" id="services">
                      <div className="detail-title">
                        <h4>Services</h4>
                      </div>

                      <ul className="special-links scroll-mobile">
                        {company?.companyServices?.map((services, index) => (
                          <li key={index}>
                            <a href="/" role="button" onClick={(e) => e.preventDefault()}>
                              {services.service}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="doc-information-details" id="clinic">
                      <div className="detail-title">
                        <h4>Hospital &amp; Locations</h4>
                      </div>
                      <div className="clinic-loc">
                        <div className="row align-items-center">
                          <div className="col-lg-7">
                            <div className="clinic-info row">
                              <div className="col-sm-4 col-12"><img src={`${serverConfig.BASE_URL}/uploads/company/${company?.company?.logoImg}`} alt="asd"
                                className="clinic-img  image"
                                onError={(e) => {
                                  e.target.onerror = null; // prevents infinite loop
                                  e.target.src = "assets/img/hospital.jpg";
                                }} /></div>
                              <div className="detail-clinic col-sm-8 col-12 mt-3 mt-sm-0">
                                <h5>{company?.company?.companyName}- </h5>
                                {/* &#8377; {company?.company?.consultationFee} */}
                                {/* <span> / Apponitment</span> */}
                                <p>{company?.company?.officeAddress}</p>
                              </div>
                            </div>
                            {/* <div className="d-flex align-items-center avail-time-slot">
                    <div className="availability-date">
                      <div className="book-date">
                        <h6>Monday</h6>
                        <span>07:00 AM - 09:00 PM</span>
                      </div>
                    </div>
                    <div className="availability-date">
                      <div className="book-date">
                        <h6>Tuesday</h6>
                        <span>07:00 AM - 09:00 PM</span>
                      </div>
                    </div>
                  </div> */}
                          </div>
                          <div className="col-lg-5">
                            <div className="contact-map d-flex">
                              <iframe title="some thing" src={(company?.company?.mapSrcLocation) ? `${company?.company?.mapSrcLocation}` : `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.7301009561315!2d-76.13077892422932!3d36.82498697224007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89bae976cfe9f8af%3A0xa61eac05156fbdb9!2sBeachStreet%20USA!5e0!3m2!1sen!2sin!4v1669777904208!5m2!1sen!2sin`} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="clinic-loc mb-0">
              <div className="row align-items-center">
                <div className="col-lg-7">
                  <div className="clinic-info">
                    <div className="clinic-img"><img src="assets/img/clinic/clinic-10.jpg" alt="Img" /></div>
                    <div className="detail-clinic">
                      <h5>The Family Dentistry Clinic </h5>
                      <span>$550 / Apponitment</span>
                      <p>MDS - Periodontology and Oral Implantology, BDS</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center avail-time-slot">
                    <div className="availability-date">
                      <div className="book-date">
                        <h6>Friday</h6>
                        <span>07:00 AM - 09:00 PM</span>
                      </div>
                    </div>
                    <div className="availability-date">
                      <div className="book-date">
                        <h6>Saturday</h6>
                        <span>07:00 AM - 09:00 PM</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="contact-map d-flex">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.7301009561315!2d-76.13077892422932!3d36.82498697224007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89bae976cfe9f8af%3A0xa61eac05156fbdb9!2sBeachStreet%20USA!5e0!3m2!1sen!2sin!4v1669777904208!5m2!1sen!2sin" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
                  </div>
                </div>
              </div>
            </div> */}
                    </div>

                    {/* <div className="doc-information-details" id="review">
            <div className="detail-title">
              <h4>Reviews (200)</h4>
            </div>
            <div className="doc-review-card">
              <div className="user-info-review">
                <div className="reviewer-img">
                  <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="avatar-img"><img src="assets/img/clients/client-13.jpg" alt="asd" /></a>
                  <div className="review-star">
                    <a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>kadajsalamander</a>
                    <div className="rating">
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <span>5.0 | 2 days ago</span>
                    </div>
                  </div>
                </div>
                <span className="thumb-icon"><i className="fa-regular fa-thumbs-up" />Yes,Recommend for Appointment</span>
              </div>
              <p>Thank you for this informative article! I've had a couple of hit-and-miss experiences with 
                freelancers in the past, and I realize now that I wasn't vetting them properly. Your checklist 
                for choosing the right freelancer is going to be my go-to from now on
              </p>
              <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="reply d-flex align-items-center"><i className="fa-solid fa-reply me-2" />Reply</a>
            </div>
            <div className="doc-review-card">
              <div className="user-info-review">
                <div className="reviewer-img">
                  <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="avatar-img"><img src="assets/img/clients/client-14.jpg" alt="asd" /></a>
                  <div className="review-star">
                    <a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>Dane jose</a>
                    <div className="rating">
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <span>5.0 | 1 Months ago</span>
                    </div>
                  </div>
                </div>
                <span className="thumb-icon"><i className="fa-regular fa-thumbs-up" />Yes,Recommend for Appointment</span>
              </div>
              <p>As a freelancer myself, I find this article spot on! It's important for clients to 
                understand what to look for in a freelancer and how to foster a good working relationship. 
                The point about mutual respect 
                and clear communication is key in my experience. Well done
              </p>
              <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="reply d-flex align-items-center"><i className="fa-solid fa-reply me-2" />Reply</a>
            </div>
            <div className="doc-review-card mb-0">
              <div className="user-info-review">
                <div className="reviewer-img">
                  <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="avatar-img"><img src="assets/img/clients/client-15.jpg" alt="asd" /></a>
                  <div className="review-star">
                    <a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>Dane jose</a>
                    <div className="rating">
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <i className="fas fa-star filled" />
                      <span>5.0 | 15 days ago</span>
                    </div>
                  </div>
                </div>
                <span className="thumb-icon"><i className="fa-regular fa-thumbs-up" />Yes,Recommend for Appointment</span>
              </div>
              <p>Great article! I've bookmarked it for future reference. I'd love to read more about managing long-term relationships with freelancers, if you have any tips on that.
              </p>
              <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="reply d-flex align-items-center"><i className="fa-solid fa-reply me-2" />Reply</a>
              <div className="replied-info">
                <div className="user-info-review">
                  <div className="reviewer-img">
                    <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="avatar-img"><img src="assets/img/clients/client-15.jpg" alt="asd" /></a>
                    <div className="review-star">
                      <a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>Robert Hollenbeck</a>
                    </div>
                  </div>
                </div>
                <p>Thank you for your comment and I will try to make a another post on that topic.
                </p>
                <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="reply d-flex align-items-center"><i className="fa-solid fa-reply me-2" />Reply</a>
              </div>
              {/* Pagination */}
                    {/* <div className="pagination dashboard-pagination">
                <ul>
                  <li>
                    <button className="page-link prev-link"><i className="fa-solid fa-chevron-left me-2" />Prev</button>
                  </li>
                  <li>
                    <button className="page-link active">1</button>
                  </li>
                  <li>
                    <button className="page-link">2</button>
                  </li>
                  <li>
                    <button className="page-link">3</button>
                  </li>
                  <li>
                    <button className="page-link">4</button>
                  </li>
                  <li>
                    <button className="page-link">5</button>
                  </li>
                  <li>
                    <button className="page-link">6</button>
                  </li>
                  <li>
                    <button className="page-link next-link">Next<i className="fa-solid fa-chevron-right ms-2" /></button>
                  </li>
                </ul>
              </div> */}
                    {/* /Pagination */}
                    {/*</div>
          </div> */}
                  </div>
                </div>
              </div>
            </div>
            {/* /Page Content */}
          </div>)}
    </>
  )
};